<app-menu></app-menu>

<section class="feed-shell">
  <div class="container-fluid">
    <div class="row g-3">
      <aside class="col-12 col-lg-3">
        <div class="feed-left-column">
          <div class="feed-card attention-card">
            <h4 class="attention-title">O que precisa da sua atenção</h4>

            <div class="attention-item clickable"
                 role="button"
                 tabindex="0"
                 (click)="openPendingList()"
                 (keydown.enter)="openPendingList()"
                 (keydown.space)="openPendingList(); $event.preventDefault()">
              <div class="attention-icon danger">
                <mat-icon>assignment</mat-icon>
              </div>
              <div class="attention-content">
                <strong class="attention-head">
                  <span>Documentos</span>
                  <span class="attention-counter" *ngIf="publicDocumentsCount > 0">{{ publicDocumentsCount }}</span>
                </strong>
                <span>Clique para visualizar documentos pendentes e gerais.</span>
              </div>
            </div>

            <div class="attention-item clickable"
                 role="button"
                 tabindex="0"
                 (click)="openQuestionnaireInbox()"
                 (keydown.enter)="openQuestionnaireInbox()"
                 (keydown.space)="openQuestionnaireInbox(); $event.preventDefault()">
              <div class="attention-icon info">
                <mat-icon>quiz</mat-icon>
              </div>
              <div class="attention-content">
                <strong class="attention-head">
                  <span>Questionário pendente</span>
                  <span class="attention-counter" *ngIf="pendingQuestionnaires.length > 0">{{ pendingQuestionnaires.length }}</span>
                </strong>
                <span>{{ attentionQuestionnaireTitle }}</span>
              </div>
            </div>

            <div class="attention-item">
              <div class="attention-icon warning">
                <mat-icon>schedule</mat-icon>
              </div>
              <div class="attention-content">
                <strong>Tarefa atrasada</strong>
                <ng-container *ngIf="loadingOverdueTask">
                  <span>Carregando tarefa...</span>
                </ng-container>
                <ng-container *ngIf="!loadingOverdueTask && overdueTask; else noOverdueTask">
                  <span>{{ overdueTask.title }}</span>
                  <small>{{ overdueTaskDelayLabel }}</small>
                </ng-container>
                <ng-template #noOverdueTask>
                  <span>Nenhuma tarefa atrasada.</span>
                </ng-template>
              </div>
            </div>

            <div class="attention-item">
              <div class="attention-icon success">
                <mat-icon>campaign</mat-icon>
              </div>
              <div class="attention-content">
                <strong>Novo comunicado</strong>
                <span class="highlight-link">{{ latestCommunicationTitle }}</span>
              </div>
            </div>

          </div>

          <div class="feed-card mood-thermometer-card">
            <h5>Termômetro de humor</h5>
            <p class="mood-question" *ngIf="!hasMoodRegistered">Como você se sente hoje?</p>
            <div class="mood-options" *ngIf="!hasMoodRegistered">
              <button
                type="button"
                *ngFor="let option of moodOptions"
                (click)="selectMood(option.id)"
                [disabled]="savingMood"
                [class.active]="selectedMood === option.id"
                [attr.aria-label]="option.labelKey | translate">
                <span>{{ option.emoji }}</span>
              </button>
            </div>
            <p class="mood-feedback" *ngIf="moodFeedback">{{ moodFeedback }}</p>
            <div class="mood-summary">
              <p class="mood-summary-status" *ngIf="moodSummaryLoading">Carregando média...</p>
              <ng-container *ngIf="!moodSummaryLoading">
                <p class="mood-summary-status" *ngIf="!moodSummaryTotal">Sem respostas nos últimos 30 dias.</p>
                <div class="mood-summary-row" *ngFor="let row of moodSummaryRows">
                  <span class="mood-emoji">{{ row.emoji }}</span>
                  <div class="mood-track">
                    <span class="mood-fill" [style.width.%]="row.percent"></span>
                  </div>
                  <span class="mood-value">{{ row.percent | number:'1.0-0' }}%</span>
                </div>
                <small class="mood-summary-total" *ngIf="moodSummaryTotal">
                  {{ moodSummaryTotal }} resposta(s) no período
                </small>
              </ng-container>
            </div>
          </div>

          <ng-container *ngIf="isAdminOrMaster">
            <div class="feed-card attention-links-card">
              <div class="collapsible-card-header">
                <h5>Acessos rápidos</h5>
                <button type="button" class="collapse-toggle" (click)="toggleAdminCard('quickLinks')">
                  <mat-icon>{{ adminCardsOpen.quickLinks ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
              </div>
              <div class="attention-links" *ngIf="adminCardsOpen.quickLinks">
                <div class="attention-link-item">Políticas {{ tenantDisplayName }}</div>
                <div class="attention-link-item">Meu calendário</div>
                <div class="attention-link-item">Minhas responsabilidades</div>
              </div>
            </div>

            <div class="feed-card admin-utility-card">
              <div class="collapsible-card-header">
                <h5>Meus certificados</h5>
                <button type="button" class="collapse-toggle" (click)="toggleAdminCard('certificates')">
                  <mat-icon>{{ adminCardsOpen.certificates ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
              </div>
              <ng-container *ngIf="adminCardsOpen.certificates">
                <p>Consulte os certificados e comprovantes emitidos no tenant.</p>
                <a class="utility-link" routerLink="/controlsign">Ver certificados</a>
              </ng-container>
            </div>

            <div class="feed-card admin-utility-card">
              <div class="collapsible-card-header">
                <h5>Minhas solicitações</h5>
                <button type="button" class="collapse-toggle" (click)="toggleAdminCard('requests')">
                  <mat-icon>{{ adminCardsOpen.requests ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
              </div>
              <ng-container *ngIf="adminCardsOpen.requests">
                <p *ngIf="loadingMyRequests">Carregando solicitações...</p>
                <p *ngIf="!loadingMyRequests">{{ myRequestsOpenCount }} solicitação(ões) em aberto.</p>
                <a class="utility-link" routerLink="/controlhelp">Ir para solicitações</a>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </aside>

      <main class="col-12 col-lg-6">
        <div class="feed-timeline">
          <div class="list-status error" *ngIf="postsError">{{ postsError }}</div>

          <article class="timeline-item" *ngFor="let item of visibleTimelineItems; let i = index">
            <div class="timeline-marker">
              <div class="timeline-avatar" [class.birthday]="item.kind === 'birthday'">
                <ng-container *ngIf="timelineAvatarUrl(item); else timelineAvatarInitial">
                  <img [src]="timelineAvatarUrl(item)" alt="Avatar">
                </ng-container>
                <ng-template #timelineAvatarInitial>
                  {{ timelineAuthor(item).charAt(0).toUpperCase() }}
                </ng-template>
              </div>
              <div class="timeline-line" *ngIf="i < visibleTimelineItems.length - 1"></div>
            </div>

            <div class="timeline-content feed-card">
              <header class="timeline-header">
                <div class="timeline-author-row">
                  <strong>{{ timelineAuthor(item) }}</strong>
                  <span class="dot">·</span>
                  <span>{{ timelineTimeLabel(item.postedAt) }}</span>
                </div>
              </header>

              <ng-container [ngSwitch]="item.kind">
                <ng-container *ngSwitchCase="'birthday'">
                  <h4 class="timeline-title">{{ birthdayTimelineTitle(item) }}</h4>
                  <p class="timeline-subtitle">{{ birthdayTimelineSubtitle(item) }}</p>
                  <div class="timeline-actions">
                    <button type="button"
                            class="like-only"
                            (click)="toggleBirthdayLike(item)"
                            [class.liked]="item.liked">
                      <mat-icon>{{ item.liked ? 'favorite' : 'favorite_border' }}</mat-icon>
                      Curtir
                      <span class="count">{{ item.likesCount }}</span>
                    </button>
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <div class="timeline-text-block" *ngIf="item.post.content_text">
                    <p class="timeline-title" [class.is-collapsed]="!isPostExpanded(item.post)">
                      {{ item.post.content_text }}
                    </p>
                    <button
                      type="button"
                      class="post-expand-btn"
                      *ngIf="isPostExpandable(item.post)"
                      (click)="togglePostExpanded(item.post)">
                      {{ isPostExpanded(item.post) ? 'Ver menos' : 'Ver mais' }}
                    </button>
                  </div>
                  <ng-container *ngIf="isCarousel(item.post); else singleMediaBlock">
                    <div class="carousel-mosaic" *ngIf="item.post.mediaUrls?.length"
                         [class.two-items]="item.post.mediaUrls.length === 2"
                         [class.three-items]="item.post.mediaUrls.length === 3">
                      <div class="mosaic-main" (click)="previewImage = formatFileUrl(item.post.mediaUrls[0])">
                        <img [src]="formatFileUrl(item.post.mediaUrls[0])" alt="Imagem principal do carrossel">
                      </div>
                      <div class="mosaic-column" *ngIf="item.post.mediaUrls.length > 1">
                        <div class="mosaic-item"
                             *ngFor="let media of item.post.mediaUrls.slice(1,5); let idx = index"
                             (click)="previewImage = formatFileUrl(media)">
                          <img [src]="formatFileUrl(media)" alt="Imagem adicional do carrossel">
                          <div class="more-overlay" *ngIf="idx === 3 && item.post.mediaUrls.length > 5">
                            +{{ item.post.mediaUrls.length - 5 }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #singleMediaBlock>
                    <ng-container *ngIf="item.post.file_url || item.post.mediaUrls?.length">
                      <ng-container *ngIf="isVideo(item.post); else singleImage">
                        <video [src]="formatFileUrl(item.post.mediaUrls?.[0] || item.post.file_url)" controls class="post-video"></video>
                      </ng-container>
                      <ng-template #singleImage>
                        <img [src]="formatFileUrl(item.post.mediaUrls?.[0] || item.post.file_url)" alt="Postagem" class="post-imagem" (click)="previewImage = formatFileUrl(item.post.mediaUrls?.[0] || item.post.file_url)">
                      </ng-template>
                    </ng-container>
                  </ng-template>

                  <div class="timeline-actions">
                    <button type="button"
                            *ngIf="item.post.allow_likes"
                            (click)="toggleLike(item.post)"
                            [class.liked]="item.post.liked">
                      <mat-icon>{{ item.post.liked ? 'favorite' : 'favorite_border' }}</mat-icon>
                      Curtir
                      <span class="count">{{ item.post.likesCount || 0 }}</span>
                    </button>
                    <button type="button"
                            *ngIf="item.post.allow_comments"
                            (click)="toggleComments(item.post)"
                            [class.active]="item.post.commentsVisible">
                      <mat-icon>chat_bubble_outline</mat-icon>
                      Comentários
                      <span class="count">{{ item.post.commentsCount || 0 }}</span>
                    </button>
                  </div>

                  <div class="post-comments" *ngIf="item.post.allow_comments && item.post.commentsVisible">
                    <div class="comment-form">
                      <textarea [(ngModel)]="item.post.newComment"
                                [placeholder]="'INTRANET.POST.COMMENT_PLACEHOLDER' | translate"
                                rows="2"></textarea>
                      <div class="emoji-picker">
                        <button type="button" *ngFor="let emoji of commentEmojis" (click)="addEmoji(item.post, emoji)">{{ emoji }}</button>
                      </div>
                      <button type="button"
                              (click)="submitComment(item.post)"
                              [disabled]="!item.post.newComment?.trim() || item.post.submittingComment">
                        {{ item.post.submittingComment ? ('INTRANET.POST.SUBMITTING' | translate) : ('INTRANET.POST.SUBMIT' | translate) }}
                      </button>
                    </div>
                    <div class="comments-wrapper">
                      <p class="comment-status" *ngIf="item.post.commentsLoading">{{ 'INTRANET.POST.COMMENTS_LOADING' | translate }}</p>
                      <p class="comment-status error" *ngIf="item.post.commentsError && !item.post.commentsLoading">{{ item.post.commentsError }}</p>
                      <p class="comment-status" *ngIf="!item.post.commentsLoading && !item.post.comments?.length">{{ 'INTRANET.POST.COMMENTS_EMPTY' | translate }}</p>
                      <div class="comment" *ngFor="let comment of item.post.comments">
                        <div class="comment-avatar">
                          <ng-container *ngIf="comment.picture_user; else commentInitial">
                            <img [src]="formatFileUrl(comment.picture_user)" alt="avatar">
                          </ng-container>
                          <ng-template #commentInitial>
                            {{ (comment.author_name || 'U').charAt(0).toUpperCase() }}
                          </ng-template>
                        </div>
                        <div class="comment-body">
                          <p>
                            <strong>{{ comment.author_name || 'Usuário' }}</strong>
                            <span>{{ comment.created_at | date:'short' }}</span>
                          </p>
                          <p>{{ comment.comment_text }}</p>
                        </div>
                      </div>
                      <div class="comment-actions" *ngIf="item.post.commentsVisible">
                        <button type="button" *ngIf="!item.post.commentsEnd" (click)="loadMoreComments(item.post)" [disabled]="item.post.commentsLoading">
                          {{ item.post.commentsLoading ? 'Carregando...' : 'Carregar mais comentários' }}
                        </button>
                        <button type="button" class="ghost" (click)="closeComments(item.post)">Fechar comentários</button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </article>

          <div class="feed-card empty-feed" *ngIf="!loadingPosts && !visibleTimelineItems.length && !postsError">
            <mat-icon>inbox</mat-icon>
            <h4>Ops! Ainda não há posts por aqui.</h4>
            <p>Quando alguém compartilhar novidades, elas vão aparecer neste espaço.</p>
          </div>

          <button type="button" class="btn-load-more" *ngIf="!loadingPosts && showLoadMoreButton()" (click)="loadMorePosts()">
            Carregar mais posts
          </button>
        </div>
      </main>

      <aside class="col-12 col-lg-3">
        <div class="feed-right-column">
          <div class="feed-card day-overview-card">
            <div class="day-overview-header">
              <h4>Seu dia no ControlPS</h4>
            </div>

            <div class="day-profile">
              <label class="day-avatar day-avatar-uploader" [class.is-uploading]="uploadingAvatar" aria-label="Alterar foto de perfil">
                <input type="file"
                       accept="image/*"
                       (change)="onAvatarSelected($event)"
                       [disabled]="uploadingAvatar">
                <ng-container *ngIf="avatarUrl; else dayAvatarFallback">
                  <img [src]="avatarUrl" alt="Foto de {{ userName || 'Usuário' }}">
                </ng-container>
                <ng-template #dayAvatarFallback>
                  {{ (userName || 'Usuário').charAt(0).toUpperCase() }}
                </ng-template>
                <span class="day-avatar-overlay">{{ uploadingAvatar ? 'Enviando...' : 'Alterar foto' }}</span>
              </label>
              <div class="day-profile-info">
                <strong>{{ formatDisplayName(userName || 'Usuário') }}</strong>
                <span>{{ currentUser?.role_name || currentUser?.role?.name || 'Colaborador' }}</span>
                <span>Brasil · São Paulo</span>
              </div>
            </div>

            <ul class="day-metrics">
              <li class="mood-row" [class.done]="hasMoodRegistered">
                <mat-icon class="metric-icon mood">check</mat-icon>
                <span>Humor enviado?</span>
                <mat-icon class="metric-check">{{ hasMoodRegistered ? 'check' : 'schedule' }}</mat-icon>
              </li>
              <li class="metric-clickable"
                  role="button"
                  tabindex="0"
                  (click)="toggleDayMetric('TASKS')"
                  (keydown.enter)="toggleDayMetric('TASKS')"
                  (keydown.space)="toggleDayMetric('TASKS'); $event.preventDefault()">
                <mat-icon class="metric-icon tasks">receipt_long</mat-icon>
                <span>Tarefas hoje</span>
                <strong>{{ todayTasksCount }}</strong>
              </li>
              <li class="metric-clickable"
                  role="button"
                  tabindex="0"
                  (click)="toggleDayMetric('PENDING')"
                  (keydown.enter)="toggleDayMetric('PENDING')"
                  (keydown.space)="toggleDayMetric('PENDING'); $event.preventDefault()">
                <mat-icon class="metric-icon pending">inventory_2</mat-icon>
                <span>Pendências</span>
                <strong>{{ pendingDocumentsCount }}</strong>
              </li>
              <li *ngIf="canViewModule('controlproject')"
                  class="metric-clickable"
                  role="button"
                  tabindex="0"
                  (click)="toggleDayMetric('PROJECTS')"
                  (keydown.enter)="toggleDayMetric('PROJECTS')"
                  (keydown.space)="toggleDayMetric('PROJECTS'); $event.preventDefault()">
                <mat-icon class="metric-icon projects">dashboard_customize</mat-icon>
                <span>Projetos ativos</span>
                <strong>{{ activeProjectsCount }}</strong>
              </li>
            </ul>

            <div class="day-metric-tooltip" *ngIf="openDayMetric">
              <div class="tooltip-header">
                <strong>{{ dayMetricTitle }}</strong>
                <button type="button" (click)="closeDayMetricTooltip()" aria-label="Fechar">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <p class="tooltip-empty" *ngIf="!dayMetricItems.length">{{ dayMetricEmptyText }}</p>
              <ul *ngIf="dayMetricItems.length">
                <li *ngFor="let item of dayMetricItems">{{ item }}</li>
              </ul>
            </div>
          </div>

          <div class="feed-card month-birthdays-card">
            <div class="month-birthdays-header">
              <h4>Aniversariantes do mês</h4>
              <div class="month-label-line">
                <span>{{ currentMonthLabel | uppercase }}</span>
              </div>
            </div>

            <p class="widget-empty" *ngIf="birthdaysLoading">Carregando aniversariantes...</p>
            <p class="widget-empty" *ngIf="birthdaysError">{{ birthdaysError }}</p>

            <div class="month-birthday-list" *ngIf="!birthdaysLoading && !birthdaysError">
              <article class="month-birthday-item" *ngFor="let person of visibleMonthBirthdays">
                <div class="month-birthday-avatar" [class.has-photo]="person.pictureUrl">
                  <ng-container *ngIf="person.pictureUrl; else monthBirthdayInitial">
                    <img [src]="person.pictureUrl" alt="Foto de {{ person.name }}">
                  </ng-container>
                  <ng-template #monthBirthdayInitial>
                    {{ person.name.charAt(0).toUpperCase() }}
                  </ng-template>
                </div>
                <div class="month-birthday-info">
                  <strong>{{ formatDisplayName(person.name) }}</strong>
                  <span class="birthday-date">{{ formatBirthdayDate(person.birthDate) }}</span>
                  <small *ngIf="person.departmentLabel && person.departmentLabel !== 'Sem departamento'">
                    {{ person.departmentLabel }}
                  </small>
                </div>
              </article>
              <p class="widget-empty" *ngIf="!monthBirthdays.length">Nenhum aniversariante neste mês.</p>
            </div>

            <button type="button" class="month-footer-link" (click)="openPendingList()">Ver documentos</button>
          </div>
        </div>
      </aside>
    </div>
  </div>
</section>

<div class="feed-popup-backdrop" *ngIf="popupVisible && activePopup?.mediaUrls?.length" (click)="closePopup()">
  <div class="feed-popup-card" (click)="$event.stopPropagation()">
    <button type="button" class="close" (click)="closePopup()">&times;</button>
    <img [src]="formatFileUrl(activePopup.mediaUrls[0])" alt="Popup">
  </div>
</div>

<div class="image-modal-backdrop" *ngIf="previewImage" (click)="previewImage = null">
  <div class="image-modal" (click)="$event.stopPropagation()">
    <button type="button" class="close" (click)="previewImage = null">&times;</button>
    <img [src]="previewImage" alt="Imagem ampliada">
  </div>
</div>

<div class="feed-modal-backdrop" *ngIf="pendingModalOpen" (click)="closePendingModal()"></div>
<section class="feed-modal pending-list" *ngIf="pendingModalOpen" (click)="$event.stopPropagation()">
  <header class="pending-header">
    <div>
      <span class="pending-badge">DOCUMENTOS · INTRANET</span>
      <h3>Documentos</h3>
      <p class="subtitle">Acesse os documentos pendentes e públicos da intranet.</p>
    </div>
    <button type="button" class="close" (click)="closePendingModal()" aria-label="Fechar modal">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="pending-divider"></div>

  <section class="pending-body">
    <div class="pending-tabs">
      <button type="button" [class.active]="pendingModalTab === 'public'" (click)="setPendingModalTab('public')">
        Públicos
        <span>{{ publicDocumentsCount }}</span>
      </button>
      <button type="button" [class.active]="pendingModalTab === 'pending'" (click)="setPendingModalTab('pending')">
        Pendentes
        <span>{{ pendingDocumentsCount }}</span>
      </button>
    </div>

    <ng-container *ngIf="pendingModalTab === 'public'; else pendingDocumentsTab">
      <h4 class="pending-group-title">Públicos</h4>
      <div class="list-status" *ngIf="loadingPublicDocs">Carregando documentos públicos...</div>
      <div class="list-status" *ngIf="!loadingPublicDocs && !publicDocuments.length">Nenhum documento público disponível.</div>

      <article class="pending-doc-row" *ngFor="let task of publicDocuments">
        <div class="pending-doc-content">
          <h4>{{ task.title || ('Documento #' + task.id) }}</h4>
          <div class="doc-tags">
            <span>{{ (task.posted_at || task.created_at) | date:'short' }}</span>
          </div>
        </div>
        <button type="button" class="pending-view-btn" (click)="openPublicDocumentTask(task)">Visualizar</button>
      </article>
    </ng-container>

    <ng-template #pendingDocumentsTab>
      <h4 class="pending-group-title">Pendentes</h4>
      <div class="list-status" *ngIf="loadingPendingDocs">Carregando documentos...</div>
      <div class="list-status" *ngIf="!loadingPendingDocs && !pendingDocuments.length">Nenhum documento pendente.</div>

      <article class="pending-doc-row" *ngFor="let task of pendingDocuments">
        <div class="pending-doc-content">
          <h4>{{ task.title }}</h4>
          <div class="doc-tags">
            <span>{{ formatDocumentTypeLabel(task.document_type) }}</span>
            <span>{{ task.sent_at | date:'short' }}</span>
          </div>
        </div>
        <button type="button" class="pending-view-btn" (click)="openDocumentTask(task)">Visualizar</button>
      </article>
    </ng-template>
  </section>

  <footer class="pending-footer">
    <button type="button" class="pending-cancel-btn" (click)="closePendingModal()">Cancelar</button>
  </footer>
</section>

<div class="feed-modal-backdrop" *ngIf="documentModalOpen" (click)="closeDocumentModal()"></div>
<section class="feed-modal document-detail" *ngIf="documentModalOpen && selectedTask" (click)="$event.stopPropagation()">
  <header class="document-header">
    <div>
      <h3>{{ selectedTask?.title }}</h3>
      <p class="subtitle">
        <ng-container *ngIf="selectedTaskMode === 'public'; else pendingDocumentSubtitle">
          Documento publicado em {{ (selectedTask?.posted_at || selectedTask?.created_at) | date:'short' }}
        </ng-container>
        <ng-template #pendingDocumentSubtitle>
          Documento enviado em {{ selectedTask?.sent_at | date:'short' }}
        </ng-template>
      </p>
    </div>
    <button type="button" class="close" (click)="closeDocumentModal()" aria-label="Fechar modal">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="document-divider"></div>
  <div class="doc-viewer" (scroll)="onDocumentScroll($event)" *ngIf="!selfieCaptureMode">
    <iframe *ngIf="safeDocumentUrl" [src]="safeDocumentUrl" frameborder="0"></iframe>
    <p *ngIf="!safeDocumentUrl" class="list-status">Não foi possível carregar o documento no momento. Tente novamente mais tarde.</p>
  </div>
  <p class="reading-hint" [class.active]="documentScrollReady" *ngIf="!selfieCaptureMode && selectedTaskMode !== 'public'">
    {{ documentScrollReady ? 'Você pode continuar.' : 'Role até o final do documento para habilitar as confirmações.' }}
  </p>
  <div class="doc-actions" [class.disabled]="!documentScrollReady" *ngIf="!selfieCaptureMode && selectedTaskMode !== 'public'">
    <label *ngFor="let action of documentActionsChecklist">
      <input type="checkbox" [checked]="action.completed" (change)="toggleChecklistItem(action)">
      {{ action.label }}
    </label>
    <p *ngIf="!documentActionsChecklist.length" class="hint">Nenhuma confirmação adicional é necessária.</p>
  </div>

  <section class="selfie-capture-stage" *ngIf="selectedTaskMode !== 'public' && requiresSelfie() && selfieCaptureMode">
    <h4>Assinar com selfie</h4>
    <p class="hint">Posicione o rosto no centro da máscara e capture a foto.</p>
    <div class="selfie-camera-mask">
      <video #selfieVideo autoplay playsinline muted></video>
      <canvas #selfieCanvas></canvas>
      <div class="selfie-mask-guide"></div>
    </div>
    <div class="selfie-capture-actions">
      <button type="button" class="ghost-evidence" (click)="cancelSelfieSignature()">Cancelar</button>
      <button type="button" (click)="captureSelfieFromCamera()">Capturar foto</button>
    </div>
    <p class="hint error" *ngIf="cameraError">{{ cameraError }}</p>
  </section>

  <div class="evidence-grid" *ngIf="selectedTaskMode !== 'public' && (requiresGeolocation() || (requiresSelfie() && !selfieCaptureMode))">
    <div class="evidence-card" *ngIf="requiresGeolocation()">
      <h4>Geolocalização obrigatória</h4>
      <p class="hint">Capture sua localização atual para compor a prova digital.</p>
      <div class="geo-status" *ngIf="locationEvidence; else noGeo">
        <strong>{{ locationEvidence.latitude | number:'1.4-6' }}, {{ locationEvidence.longitude | number:'1.4-6' }}</strong>
        <small *ngIf="locationEvidence.accuracy">Precisão: {{ locationEvidence.accuracy | number:'1.0-0' }}m</small>
      </div>
      <ng-template #noGeo>
        <p class="hint muted">Nenhuma localização capturada.</p>
      </ng-template>
      <p class="hint error" *ngIf="locationError">{{ locationError }}</p>
      <button type="button" class="ghost-evidence" (click)="captureGeolocation()" [disabled]="locationLoading">
        {{ locationLoading ? 'Capturando...' : (locationEvidence ? 'Atualizar localização' : 'Capturar localização') }}
      </button>
    </div>

    <div class="evidence-card" *ngIf="requiresSelfie() && !selfieCaptureMode">
      <h4>Selfie obrigatória</h4>
      <p class="hint">Use a câmera para registrar a selfie obrigatória desta assinatura.</p>
      <div class="selfie-result" *ngIf="selfiePreview">
        <img [src]="selfiePreview" alt="Selfie capturada">
        <span>Selfie capturada com sucesso.</span>
      </div>
      <button type="button" class="selfie-sign-btn" (click)="beginSelfieSignature()" [disabled]="cameraLoading">
        {{ selfiePreview ? 'ASSINAR COM SELFIE (REFAZER)' : 'ASSINAR COM SELFIE' }}
      </button>
    </div>
  </div>

  <div class="feedback document-feedback" *ngIf="documentFeedback">{{ documentFeedback }}</div>
  <div class="doc-buttons" *ngIf="selectedTaskMode !== 'public'">
    <button type="button" (click)="completeDocumentAction()" [disabled]="!canSubmitDocumentAction()">Concluir documento</button>
  </div>
</section>
